// import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing";

// if(process.env.UMI_ENV === 'production') {
//   Sentry.init({
//     dsn: "https://73520231fae3447282130a94f332d5bf@sentry.233xyx.com/26", // 换成真实的dsn
//     integrations: [new Integrations.BrowserTracing()],
//   });
// }

/**
 * 0: wl_zijin 正式服
 * 1: dev_wl_zijin 测试服
 * 2: pre_wl_zijin 预发测试服
 */
function indexTypeByEnv() {
  let type = 1;
  process.env.NODE_ENV === 'development' ? (type = 1) : (type = 0);
  switch (type) {
    case 0:
      return 'wl_zijin';
    case 1:
      return 'dev_wl_zijin';
    case 2:
      return 'pre_wl_zijin ';
    default:
      console.log('Param Error!');
  }
}

/**
 * pandora 初始化
 */
window.Pandora.send('config', {
  index_type: indexTypeByEnv(), // web填 'wl'一般情况；官网的是wl_233leyuan_official_website
  selfpackagename: 'com.meta.zijin', // 指定app包名；乐园：com.meta.box,小游戏：com.meta.xyx,官网：com.233leyuan.www
  send_interval: 100, // 发送间隔(ms)
  debug: true, // 调试模式
});
// start必须调用
window.Pandora.send('start');
